const BENIGN_DOM_MUTATION_MESSAGE_PATTERN = /removeChild|insertBefore|not a child of this node/i;

/**
 * Returns true for React DOM reconciliation errors caused by external DOM mutation
 * (e.g. browser translate reparenting text nodes). Requires both NotFoundError name
 * and a matching message so unrelated NotFoundError cases (IndexedDB, etc.) are not filtered.
 */
export function isBenignDomMutationError(error: unknown): boolean {
  if (!error || typeof error !== 'object') {
    return false;
  }
  const candidate = error as { name?: unknown; message?: unknown };
  if (candidate.name !== 'NotFoundError') {
    return false;
  }
  if (typeof candidate.message !== 'string') {
    return false;
  }
  return BENIGN_DOM_MUTATION_MESSAGE_PATTERN.test(candidate.message);
}
